var _excluded = ["options", "optionGroups", "getOptions", "datasourceFilters", "datasourceKey", "dependField", "children", "onSearch"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState, useContext, useRef } from 'react';
import FormContext from '../form-context';
import invariant from 'invariant';
export var compareOptions = function compareOptions(newOptions, oldOptions) {
  if (!Array.isArray(oldOptions)) {
    return true;
  }

  if ((oldOptions === null || oldOptions === void 0 ? void 0 : oldOptions.length) !== newOptions.length) {
    return true;
  }

  if (Array.isArray(oldOptions)) {
    for (var i = 0; i < oldOptions.length; i++) {
      var newOption = oldOptions[i];
      var originOption = newOptions[i];

      if (newOption.label !== originOption.label || newOption.value !== originOption.value || newOption.extraInfo !== originOption.extraInfo) {
        return true;
      }
    }
  }

  return false;
};
export var compareSelected = function compareSelected(newValue, oldValue) {
  if (_typeof(newValue) !== _typeof(oldValue)) {
    return true;
  }

  if (Array.isArray(newValue) && Array.isArray(oldValue)) {
    if (newValue.length !== oldValue.length) {
      return true;
    }

    return !newValue.every(function (v) {
      return oldValue.find(function (ov) {
        return v === ov;
      });
    });
  }

  return newValue !== oldValue;
};
export function optionsHOC(Component) {
  return function (props) {
    var options = props.options,
        optionGroups = props.optionGroups,
        getOptions = props.getOptions,
        datasourceFilters = props.datasourceFilters,
        datasourceKey = props.datasourceKey,
        dependField = props.dependField,
        children = props.children,
        _onSearch = props.onSearch,
        rest = _objectWithoutProperties(props, _excluded);

    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        updating = _useState2[0],
        setUpdating = _useState2[1];

    var _useState3 = useState(),
        _useState4 = _slicedToArray(_useState3, 2),
        _options = _useState4[0],
        setOptions = _useState4[1];

    var _useState5 = useState(),
        _useState6 = _slicedToArray(_useState5, 2),
        searchKey = _useState6[0],
        setSearchKey = _useState6[1];

    var optionsRef = useRef(_options);

    var _useContext = useContext(FormContext),
        selectDatasourceApi = _useContext.selectDatasourceApi;

    var getFormInstance = rest.getFormInstance;
    var form = typeof getFormInstance === 'function' && getFormInstance();
    var dependFieldValue = form && dependField && form.getFieldValue(dependField);
    var optionsFromGetOptions = typeof getOptions === 'function' && form && getOptions(form);
    useEffect(function () {
      if (!Array.isArray(optionsFromGetOptions)) {
        return;
      }

      if (compareOptions(optionsFromGetOptions, optionsRef.current)) {
        optionsRef.current = optionsFromGetOptions;
        setOptions(optionsFromGetOptions);
      }
    }, [optionsFromGetOptions]);
    invariant(datasourceKey && selectDatasourceApi || !datasourceKey, 'Please provide selectDatasourceApi in Form props');
    invariant(datasourceFilters && datasourceKey && selectDatasourceApi || !datasourceFilters, 'Please provide selectDatasourceApi in Form props');
    useEffect(function () {
      if (Array.isArray(optionsFromGetOptions)) {
        return;
      }

      setUpdating(true);

      var calcOptions = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _options2, query, api, rst, _yield$rst$json, data;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!Array.isArray(options)) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", options);

                case 2:
                  if (!(Array.isArray(children) || _typeof(children) === 'object')) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return", Array.isArray(children) ? children.map(function (child) {
                    return {
                      label: child.props.children,
                      value: child.props.value
                    };
                  }) : [{
                    label: children.props.children,
                    value: children.props.value
                  }]);

                case 4:
                  if (!optionGroups) {
                    _context.next = 9;
                    break;
                  }

                  if (!dependFieldValue) {
                    _context.next = 9;
                    break;
                  }

                  _options2 = [];
                  optionGroups.forEach(function (_ref2) {
                    var parentKey = _ref2.parentKey,
                        _ref2$options = _ref2.options,
                        options = _ref2$options === void 0 ? [] : _ref2$options;

                    if (Array.isArray(dependFieldValue) ? dependFieldValue.includes(parentKey) : parentKey === dependFieldValue) {
                      _options2.push.apply(_options2, _toConsumableArray(options));
                    }
                  });
                  return _context.abrupt("return", _options2);

                case 9:
                  if (!(selectDatasourceApi && datasourceKey)) {
                    _context.next = 28;
                    break;
                  }

                  query = Array.isArray(dependFieldValue) ? dependFieldValue.map(function (v) {
                    return "parent=".concat(v);
                  }).join('&') : dependFieldValue ? "parent=".concat(dependFieldValue) : '';

                  if (searchKey) {
                    query += "&search_keyword=".concat(searchKey);
                  }

                  if (datasourceFilters) {
                    query = dependFieldValue ? "".concat(query, "&") : query;
                    query += datasourceFilters.map(function (f) {
                      return "filter=".concat(f);
                    }).join('&');
                  }

                  api = "".concat(selectDatasourceApi, "/").concat(datasourceKey);
                  _context.prev = 14;
                  _context.next = 17;
                  return fetch(query ? "".concat(api, "?").concat(query) : api);

                case 17:
                  rst = _context.sent;
                  _context.next = 20;
                  return rst.json();

                case 20:
                  _yield$rst$json = _context.sent;
                  data = _yield$rst$json.data;
                  return _context.abrupt("return", data || []);

                case 25:
                  _context.prev = 25;
                  _context.t0 = _context["catch"](14);
                  return _context.abrupt("return", []);

                case 28:
                  return _context.abrupt("return", []);

                case 29:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[14, 25]]);
        }));

        return function calcOptions() {
          return _ref.apply(this, arguments);
        };
      }();

      calcOptions().then(function (newOptions) {
        if (compareOptions(newOptions, optionsRef.current)) {
          setOptions(newOptions);
          optionsRef.current = newOptions;
        }

        setUpdating(false);
      });
    }, [options, optionsFromGetOptions, optionGroups, dependFieldValue, searchKey]);
    return _options ? _jsx(Component, _objectSpread(_objectSpread({
      options: _options
    }, rest), {}, {
      onSearch: function onSearch(e) {
        setSearchKey(e);
        typeof _onSearch === 'function' && _onSearch(e);
      },
      optionsUpdating: updating
    })) : null;
  };
}
export function previewSelectedOptions(options, value) {
  var _value = [value].flat();

  var replaceLabel = _value.reduce(function (strArr, selectedValue, index) {
    var matched = options === null || options === void 0 ? void 0 : options.filter(function (originOption) {
      return originOption.value === selectedValue;
    });
    if (matched && matched[0]) strArr[index] = matched[0].label;
    return strArr;
  }, _value);

  return replaceLabel.join(',');
}